import type { FC } from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  Modal,
  Fade,
} from '@material-ui/core';

const Splash: FC<{ open: boolean }> = ({ open }) => (
  <>
    <Modal open={open}>
      <Fade>
        <Box>
          <Typography>Procesando</Typography>
          <CircularProgress />
        </Box>
      </Fade>
    </Modal>
  </>
);

export default Splash;
